module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_9-17d81a85b2d443318e83534b701e988d.png";